import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

export function hasCollectionPointAddressCompleted(
  lastCollectionPoint?: ApiSpecs['/bm/cart']['GET']['response']['lastCollectionPoint'],
) {
  return !isEmpty(lastCollectionPoint?.selectedPoint)
}
